import * as Tone from "tone"
let inst = {};

let samples = [{
    'A2' : 'scale-A2.[mp3|ogg]',
    'A3' : 'scale-A3.[mp3|ogg]',
    'C3' : 'scale-C3.[mp3|ogg]',
    'C4' : 'scale-C4.[mp3|ogg]',
    'D3' : 'scale-C3.[mp3|ogg]',
    'D4' : 'scale-D4.[mp3|ogg]',
    'E3' : 'scale-E3.[mp3|ogg]',
    'E4' : 'scale-E4.[mp3|ogg]',
    'G2' : 'scale-G2.[mp3|ogg]',
    'G3' : 'scale-G3.[mp3|ogg]',
}, {
    'attack' : 0.01,
    'release' : 0.9,
    'baseUrl' : './teropa/'
}]


let delayL = new Tone.PingPongDelay("16n", 0.96)
let delayR = new Tone.PingPongDelay("16n", 0.96)
delayL.wet.value = 0;
delayR.wet.value = 0;
let filterL = new Tone.Filter(100, "highpass", -12);
let filterR = new Tone.Filter(100, "highpass", -12);


let meterL = new Tone.Meter();
let meterR = new Tone.Meter();

let pannerL1 = new Tone.Panner(-0.0).toMaster()
let pannerL2 = new Tone.Panner(-1.0).toMaster()
let pannerL3 = new Tone.Panner(-0.2).toMaster()
let pannerR1 = new Tone.Panner(0.7).toMaster()
let pannerR2 = new Tone.Panner(0.5).toMaster()
let pannerR3 = new Tone.Panner(0.2).toMaster()
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
synthL.volume.value = -32
synthR.volume.value = -32
synthL.connect(filterL)
synthR.connect(filterR)

filterL.connect(delayL)
filterR.connect(delayR)
delayL.connect(pannerL1)
delayL.connect(pannerL2)
delayL.connect(pannerL3)
delayR.connect(pannerR1)
delayR.connect(pannerR2)
delayR.connect(pannerR3)

delayL.connect(meterL)
delayR.connect(meterR)

inst.delayL = delayL
inst.delayR = delayR
inst.filterL = filterL
inst.filterR = filterR
inst.synthL = synthL
inst.synthR = synthR
inst.meterL = meterL
inst.meterR = meterR

export default inst